import BaseRoute from 'codecrafters-frontend/utils/base-route';

export default class DebugRoute extends BaseRoute {
  allowsAnonymousAccess = true;
}
